var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Email(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 4 C 12.972292 4 4 12.972292 4 24 C 4 35.027708 12.972292 44 24 44 C 26.46846 44 28.839993 43.551537 31.027344 42.730469 A 1.50015 1.50015 0 1 0 29.972656 39.921875 C 28.116007 40.618807 26.10554 41 24 41 C 14.593708 41 7 33.406292 7 24 C 7 14.593708 14.593708 7 24 7 C 33.406292 7 41 14.593708 41 24 L 41 26.5 C 41 29.003499 39.003499 31 36.5 31 C 33.996501 31 32 29.003499 32 26.5 L 32 24 L 32 15.5 A 1.50015 1.50015 0 1 0 29 15.5 L 29 16.566406 C 27.419516 14.984362 25.331498 14 23 14 C 17.942095 14 14 18.59527 14 24 C 14 29.40473 17.942095 34 23 34 C 25.872367 34 28.382558 32.516731 30.017578 30.246094 C 31.319489 32.483151 33.739215 34 36.5 34 C 40.624501 34 44 30.624501 44 26.5 L 44 24 C 44 12.972292 35.027708 4 24 4 z M 23 17 C 26.214095 17 29 20.03073 29 24 C 29 27.96927 26.214095 31 23 31 C 19.785905 31 17 27.96927 17 24 C 17 20.03073 19.785905 17 23 17 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Email);
export default __webpack_public_path__ + "static/media/icons8-email.2f579c014f5fcbee7614ae76b22c2d45.svg";
export { ForwardRef as ReactComponent };